<template>
  <v-row no-gutters class="mx-auto my-3">
    <v-col cols="12" class="d-flex flex-wrap mb-4">
      <div v-for="(item, index) in designObject" :key="index">
        <div @click="chooseDesign(item.value)" class="m-2 p-3 qrBtn">
          <img :src="item.img" :alt="item.value" />
        </div>
      </div>
    </v-col>

    <v-col cols="12" md="6" class="pa-2" v-if="marker.different_markers_color">
      <color-picker v-model="marker.main" label="رنگ مرکز" />
    </v-col>

    <v-col cols="12" md="6" class="pa-2">
      <v-switch
        label="شخصی سازی مرکز مارکر"
        class="ma-0"
        v-model="marker.different_markers_color"
      />
    </v-col>

    <v-col cols="12" md="6" class="pa-2" v-if="marker.different_markers_color">
      <color-picker v-model="marker.topRight" label="بالا راست" />
    </v-col>

    <v-col cols="12" md="6" class="pa-2" v-if="marker.different_markers_color">
      <color-picker v-model="marker.bottomLeft" label="پایین چپ" />
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "./colorPicker.vue";

export default {
  name: "markerCenter",
  components: { ColorPicker },
  data() {
    return {
      designObject: [
        { value: "circle", img: "/media/eye/circle.svg" },
        { value: "cross", img: "/media/eye/cross.svg" },
        { value: "danger", img: "/media/eye/danger.svg" },
        { value: "diamond", img: "/media/eye/diamond.svg" },
        { value: "drop", img: "/media/eye/drop.svg" },
        { value: "dropeye", img: "/media/eye/dropeye.svg" },
        { value: "drop_in", img: "/media/eye/drop_in.svg" },
        { value: "flurry", img: "/media/eye/flurry.svg" },
        { value: "heart", img: "/media/eye/heart.svg" },
        { value: "plus", img: "/media/eye/plus.svg" },
        { value: "rounded", img: "/media/eye/rounded.svg" },
        { value: "sdoz", img: "/media/eye/sdoz.svg" },
        { value: "default", img: "/media/eye/square.svg" },
        { value: "star", img: "/media/eye/star.svg" },
        { value: "sun", img: "/media/eye/sun.svg" },
      ],
      marker: {
        topRight: "#000",
        bottomLeft: "#000",
        main: "#000",
        different_markers_color: false,
        eyePattern: "default",
      },
    };
  },
  methods: {
    chooseDesign(value) {
      this.marker.eyePattern = value;
    },
  },
  watch: {
    marker: {
      handler(value) {
        this.$emit("input", value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #02105c8c;
  cursor: pointer;
}

.qrBtn:hover {
  border-radius: 0 !important;
  box-shadow: none !important;
}
</style>
